import { Component, effect, inject, OnInit, untracked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { AuthService } from '@shared/util-auth';
import { Event, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { MenuItemService, UserStore } from '@shared/data';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: false
})
export class NavbarComponent implements OnInit {
  readonly translateService = inject(TranslateService);
  readonly authService = inject(AuthService);
  protected collapsed = false;
  protected userStore = inject(UserStore);
  protected readonly UserStore = UserStore;
  private router = inject(Router);
  private isLoaded = this.userStore.loaded;
  private menuItemService = inject(MenuItemService);
  protected items = this.menuItemService.items;

  constructor() {
    effect(() => {
      const isLoaded = this.isLoaded();
      untracked(() => {
        if (isLoaded) {
          this.getNavigationItems();
        }
      });
    });
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe(() => {
      this.getNavigationItems();
    });

    this.router.events
      .pipe(
        filter((evt: Event | RouterEvent): boolean => {
          return evt instanceof NavigationEnd;
        })
      )
      .subscribe((evt: Event | RouterEvent): void => {
        if (evt instanceof NavigationEnd) {
          if (evt.urlAfterRedirects) {
            this.getNavigationItems();
          }
        }
      });
  }

  toggle() {
    this.collapsed = !this.collapsed;
    this.getNavigationItems();
  }

  private getNavigationItems() {
    this.menuItemService.buildNavigation();
    this.menuItemService.setActiveItem(this.router.url);
  }
}
